// Public saved-result pages are embedded in forum posts. Keep the app's
// recursive-frame guard for other routes without reading parent.location,
// which is inaccessible when the forum is on a different origin.
export function isEmbeddableSharePath(path) {
    return /^\/shared\/(?:g25|admix|pca|analysis|fstats|tree)\/?$/i.test(path)
}
